import React, { createContext, useState } from 'react';

export const ConfigContextUtils = createContext();

const GeneralProviderUtils = (props) => {
    const [preloader, setPreloader] = useState(true);
    const [boleta, setBoleta] = useState(null);

    return (
        <ConfigContextUtils.Provider
          value={{
            preloader,
            setPreloader,
            boleta,
            setBoleta,
          }}
        >
          {props.children}
        </ConfigContextUtils.Provider>
      )
}

export default GeneralProviderUtils;